<template>
    <div>
        <div class="headingWizard">Make New Appointment</div>
        <div class="formConatiner">
            <div class="widthContainer">
                <div class="wizardWrapper">
                    <div class="checkout-wrap">
                        <ul class="checkout-bar">
                            <li :class="{ active: activeTab === 1, visited: activeTab > 1 }">
                                Enter Contact Details <br />
                                (1/3)
                            </li>
                            <li :class="{ active: activeTab === 2, visited: activeTab > 2 }">
                                Select Appointment Date and Time <br />
                                (2/3)
                            </li>
                            <li :class="{ active: +activeTab === 3, lastTab: +activeTab === 3 }">
                                Review Details <br />
                                (3/3)
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="tabsContainer">
                    <div class="tab" v-if="activeTab === 1">
                        <ContactDetails @nextClick="onNextAction" />
                    </div>
                    <div class="tab" v-if="activeTab === 2">
                        <ScheduleAppointment @nextClick="onNextAction" @backClick="onBackAction" />
                    </div>
                    <div class="tab" v-if="activeTab === 3">
                        <AcknowledgementDetails @nextClick="onNextAction" @backClick="onBackAction" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import ContactDetails from './contact-details.vue'
import ScheduleAppointment from './schedule-appointment.vue'
import AcknowledgementDetails from './acknowledgement-details.vue'

const store = useStore()
const activeTab = ref(1)

onBeforeMount(() => {
    // activeTab.value = store.getters.getActiveTab
})

const onNextAction = () => {
    if (activeTab.value < 3) {
        activeTab.value++
        store.dispatch('setActiveTab', activeTab.value)
    }
}

const onBackAction = () => {
    activeTab.value--
    store.dispatch('setActiveTab', activeTab.value)
}
</script>


<style>
.headingWizard {
    background: #222349;
    font-size: 32px;
    color: #fff;
    font-weight: 600;
    padding: 10px;
}

.wizardWrapper {
    float: left;
    width: 100%;
    padding-bottom: 20px;
}

@-webkit-keyframes myanimation {
    from {
        left: 0%;
    }

    to {
        left: 50%;
    }
}

.checkout-wrap {
    color: #444;
    font-family: 'PT Sans Caption', sans-serif;
    margin: 40px auto 0 auto;
    position: relative;
}

ul.checkout-bar {
    margin: 0 0px;
    padding: 0;
}

ul.checkout-bar li {
    color: #6d6d6d;
    display: block;
    font-size: 12px;
    padding: 14px 20px 14px 80px;
    position: relative;
}

ul.checkout-bar li:before {
    -webkit-box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
    box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
    background: #ddd;
    border: 2px solid #FFF;
    border-radius: 50%;
    color: #5f5f5f;
    font-size: 16px;
    font-weight: 700;
    left: 20px;
    line-height: 37px;
    height: 35px;
    position: absolute;
    text-align: center;
    top: 4px;
    width: 35px;
    z-index: 999;
}

ul.checkout-bar li.active {
    color: #3f4f9f;
    font-weight: bold;
}

ul.checkout-bar li.active:before {
    background: #3f4f9f;
    z-index: 99999;
    color: #fff;
    text-shadow: 1px 1px rgba(0, 0, 0, 0.2);
}

ul.checkout-bar li.active.notActive:before {
    background: #ddd;
    color: #5f5f5f;
    text-shadow: none;
}

ul.checkout-bar li.active.notActive {
    color: #6d6d6d;
    font-weight: normal;
}


ul.checkout-bar li.visited,
ul.checkout-bar li.lastTab {
    color: #3f4f9f;
    z-index: 99999;
}

ul.checkout-bar li.visited:before,
ul.checkout-bar li.lastTab:before {
    background: #3f4f9f;
    z-index: 99999;
    color: #fff;
    text-shadow: 1px 1px rgba(0, 0, 0, 0.2);
}

ul.checkout-bar li:nth-child(1):before {
    content: "1";
}

ul.checkout-bar li:nth-child(2):before {
    content: "2";
}

ul.checkout-bar li:nth-child(3):before {
    content: "3";
}

ul.checkout-bar li:nth-child(4):before {
    content: "4";
}

ul.checkout-bar li:nth-child(5):before {
    content: "5";
}

ul.checkout-bar li:nth-child(6):before {
    content: "6";
}

ul.checkout-bar a {
    color: #3f4f9f;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
}

.widthContainer {
    padding: 15px;
}

@media all and (min-width: 900px) {
    .widthContainer {
        width: 80%;
        margin: 0 auto;
    }
}

@media all and (min-width: 768px) {
    .checkout-bar li.active:after {
        -webkit-animation: myanimation 3s 0;
        background-size: 35px 35px;
        background-color: #8bc53f;
        -webkit-box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
        box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
        content: "";
        height: 15px;
        width: 100%;
        left: 50%;
        position: absolute;
        top: -50px;
        z-index: 0;
        display: none;
    }


    .checkout-wrap {
        margin: 80px auto;
    }

    ul.checkout-bar {
        -webkit-box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
        box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
        background-size: 35px 35px;
        background-color: #EcEcEc;
        border-radius: 15px;
        height: 15px;
        margin: 0 auto;
        padding: 0;
        position: absolute;
        width: 100%;
        z-index: 9;
    }

    ul.checkout-bar::before {
        content: "";
        position: absolute;
        left: 0;
        width: 15%;
        height: 15px;
        background-color: #3f4f9f;
        background-size: 35px 35px;
        box-shadow: inset 2px 2px 2px rgba(0, 0, 0, 0.2);
        border-radius: 15px;
        z-index: 1;
        background-image: linear-gradient(-45deg,
                rgba(255, 255, 255, 0.2) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.2) 50%,
                rgba(255, 255, 255, 0.2) 75%,
                transparent 75%,
                transparent);
    }

    ul.checkout-bar li.visited:after {
        content: "";
        position: absolute;
        left: 0;
        width: 15%;
        height: 15px;
        background-color: #3f4f9f;
        background-size: 35px 35px;
        background-image: linear-gradient(-45deg,
                rgba(255, 255, 255, 0.2) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.2) 50%,
                rgba(255, 255, 255, 0.2) 75%,
                transparent 75%,
                transparent);
        box-shadow: inset 2px 2px 2px rgba(0, 0, 0, 0.2);
        border-radius: 15px;
        z-index: 1;
    }

    ul.checkout-bar li {
        display: inline-block;
        vertical-align: top;
        margin: 50px 0 0;
        padding: 0;
        text-align: center;
        width: 32%;
    }

    ul.checkout-bar li:before {
        height: 45px;
        left: calc(50% - 25px);
        line-height: 45px;
        position: absolute;
        top: -65px;
        width: 45px;
        z-index: 99;
    }

    ul.checkout-bar li.visited {
        background: none;
    }

    ul.checkout-bar li.visited:after,
    ul.checkout-bar li.lastTab:after {
        background-size: 35px 35px;
        background-color: #3f4f9f;
        background-image: -webkit-linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
        background-image: -moz-linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
        -webkit-box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
        box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
        content: "";
        height: 15px;
        left: 50%;
        position: absolute;
        top: -50px;
        width: 100%;
        z-index: 99;
    }

    ul.checkout-bar li:last-child:after {
        border-radius: 0 8px 8px 0;
    }
}
</style>
